const featureOnlineBankingBlocks = document.querySelectorAll(".homepage-digital-block");

featureOnlineBankingBlocks.forEach(featureOnlineBanking => {
	const tabButtons: null | NodeListOf<HTMLButtonElement> = featureOnlineBanking.querySelectorAll(".js-tab-button");
	const tabs:null | NodeListOf<HTMLElement> = featureOnlineBanking.querySelectorAll(".tabs .js-tab");

    function makeActive(nodeList, index) {
        nodeList.forEach((button) => {
			if (button.dataset.tabId == index) {
				button.classList.add("active");
			} else {
				button.classList.remove("active");
			}
		});
    }

	tabButtons.forEach((button) => {
		button.addEventListener("click", (e) => {
			const activeButton: HTMLElement = e.target as HTMLElement;
			const index = activeButton.dataset.tabId;

			makeActive(tabButtons, index)

			tabs[0].parentElement.setAttribute('style', `background-image: url(${tabs[index].dataset.bgImage})`);

			makeActive(tabs, index)
		});
	});
	if (tabButtons[0]) {
		const button = tabButtons[0] as HTMLButtonElement;
		button.click();
	}
})
